import { Directive, TemplateRef, ViewContainerRef, effect, inject, input } from '@angular/core';

import { PermissionService } from '../../core/auth/permission.service';

/**
 * `*appHasPermission="'Tickets.ChangeStatus'"` -- removes the element from the DOM
 * entirely when the caller lacks the permission (UX/UI Design §1: "hide, never disable,
 * at the navigation level"). Shares PermissionService with permissionGuard so
 * route-level and element-level visibility can never disagree.
 */
@Directive({
  selector: '[appHasPermission]',
  standalone: true,
})
export class HasPermissionDirective {
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly permissionService = inject(PermissionService);

  readonly appHasPermission = input.required<string>();

  private hasView = false;

  private readonly syncView = effect(() => {
    const allowed = this.permissionService.hasPermission(this.appHasPermission());

    if (allowed && !this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!allowed && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  });
}
